/* All things Shopify JS for Repatriot V3 */
let AMB_APP = "https://jasproxy.ngrok.dev";
AMB_APP = "https://ambassador.projectrepat.com";
const AMB_QS = new URLSearchParams(document.location.search);

(async () => {

    if(document.location.pathname === "/pages/ambassador" || document.location.pathname === "/amb") {        
        const referralCode = AMB_QS?.get("a") || "";
        const ambElems = document.querySelectorAll(".ambassador-ref-container");
        if (ambElems.length > 0) {
            const formReq = await fetch(`${AMB_APP}/ref/${referralCode}`);
            const formResponse = await formReq.json();
            if (formResponse.success) {
                ambElems.forEach(elem => {
                    elem.innerHTML = formResponse.data.markup;
                });                
            } else {
                document.location = "/";
            }
        }
    }    
})();


function ambRef(resp) {
    document.querySelectorAll(".amb-ref-btn").forEach(elem => {
        elem.disabled = false;
        elem.classList.remove("disabled");
        elem.innerHTML = "Continue";
    });
    if (resp.success) {
        document.querySelectorAll(".amb-form").forEach(elem => {
            elem.style.display = "none";
        });
        document.querySelectorAll(".amb-ref-success").forEach(elem => {
            elem.style.display = "block";
        });
        document.querySelector(".lp-shop").style.display = "block";
    } else {
        document.querySelectorAll(".amb-ref-error").forEach(elem => {
            elem.style.display = "block";
        });
    }
}

// multi-purpose function to send "API" requests to the app
function ambFormGo(form) {

    document.querySelectorAll(".amb-ref-error").forEach(elem => {
        elem.style.display = "none";
    });
    document.querySelectorAll(".amb-ref-btn").forEach(elem => {
        elem.disabled = true;
        elem.classList.add("disabled");
        elem.innerHTML = "One moment...";
    });

    //get form data
    const formData = serializeForm(form);

    //send it
    formGo(`${AMB_APP}${form.getAttribute("action")}`, formData);

    return false;
}

const formGo = async (url, formData) => {

    const formReq = await fetch(url, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            "Content-Type": "text/plain;charset=utf-8"
        },
        body: JSON.stringify(formData)
    });
    const formResponse = await formReq.json();
    console.log(formResponse);

    if ("callback" in formResponse?.data && (typeof window[formResponse?.data?.callback] === "function")) {
        window[formResponse?.data?.callback](formResponse);
    }
};

// Helper function to convert form to FormData object
const serializeForm = function (form) {
    let obj = {};
    const formData = new FormData(form);
    for (let pair of formData.entries()) {
        if (pair[0] in obj) {
            obj[pair[0]] += "," + pair[1];
        } else {
            obj[pair[0]] = pair[1];
        }
    }
    return obj;
};